import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { Flags } from '@oclif/core';
import { Queue } from '@switchboard-xyz/on-demand';

export default class QueueInit extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Init a queue account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    reward: Flags.integer({
      description: 'reward for the queue account',
      required: false,
    }),
    nodeTimeout: Flags.integer({
      description: 'timeout before oracles can be removed from queue',
      required: false,
    }),
  };

  static args = {};

  async run() {
    const { flags } = await this.parse(this.constructor as typeof QueueInit);

    const program = await this.program;

    const slot = await this.connection.getSlot('finalized');
    const [queue, kp, ix] = await Queue.createIx(program, {
      allowAuthorityOverrideAfter: 600, // 10 minutes
      reward: flags.reward,
      nodeTimeout: flags.nodeTimeout,
      requireAuthorityHeartbeatPermission: true,
      requireUsagePermission: false,
      maxQuoteVerificationAge: 60 * 60 * 24 * 7, // 1 week
      lutSlot: slot,
    });

    await this.signAndSend([ix], undefined, [kp]);

    console.log();
    console.log(`Queue account: ${queue.pubkey.toBase58()}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to init a queue account');
  }
}
